module.exports = __webpack_public_path__ + "media/images/icons/online-circle-ed3cbd358ed85247f7456e2be185d4b8.svg";